import { Col, Container, Row, Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { BtnClsNames, SubmitBtnStyle } from '../../config/btn_config';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { login } from './fncs/auth_fncs';
import { useNavigate } from 'react-router-dom';


export const LoginForm = () => {
    const navigate = useNavigate();
    const [username, setUserName] = useState('')
    const [password, setPassword] = useState('')

    const handleSignIn = async (e) => {
        e.preventDefault();
        const result = await login(username,password);
        if(result){
            navigate('/')
        }else{
            toast.error('Login Failed')
        }
    }

    return (
        <Container>
            <Form onSubmit={handleSignIn}>
                <Row className='justify-content-center' style={{ paddingTop: '100px', paddingBottom: '15px' }}>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                                required
                                onChange={(e) => setUserName(e.target.value)}
                                type="text" placeholder="Username" />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                required
                                onChange={(e) => setPassword(e.target.value)}
                                type="password"
                                placeholder="Password" />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='justify-content-center mt-3'>
                    <Col xs={12} sm={10} md={6} lg={4}>
                        <Button className={BtnClsNames} style={SubmitBtnStyle} type='submit'>
                            Login
                        </Button>
                    </Col>
                </Row>

                <Row className='text-center mt-3'>
                    <Col>
                        <a href="https://yourmom.com" onClick={() => alert('where should this go?')}>Forgot your password? Click Here!</a>
                    </Col>
                </Row>
            </Form>
        </Container>
    )
}